import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = '';

export default function usePageTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    // Skip admin and login pages
    if (path.startsWith('/admin') || path === '/login') return;

    axios.post(`${API}/api/analytics/track`, {
      path,
      referrer: document.referrer || '',
      title: document.title || '',
    }).catch(() => {});
  }, [location.pathname]);
}
